<div class="toast-container">
  @for (toast of toastService.toasts(); track toast.id) {
    <app-toast [id]="toast.id" [title]="toast.title" [subtitle]="toast.subtitle" [icon]="toast.icon" [type]="toast.type" [buttons]="toast.buttons ?? []" />
  }
</div>
